import ApiService from "../../../services/api";
import moment from "moment";
import diagnosticMap from "./map.vue";
import verticalTable from "./verticalTable.vue";
import horizontalTable from "./horizontalTable.vue";
import { bus } from "../../../main";
import { mapGetters } from "vuex";
import helpers from "../../../shared/fleetbox-helpers";

export default {
	components: {
		diagnosticMap,
		horizontalTable,
		verticalTable
	},

	data: function() {
		return {
			vehicleIdFilterField: "number_plate",
			loading: false,
			positionNamePendingRequests: [],

			//filters
			showTableMapPopover: false,
			mapTableVisualizationSelected: "",

			vehicles: [],
			vehiclesSelected: [],

			drivers: [],
			driversSelected: [],

			categories: [],

			events: [],
			totalEvents: [],
			eventsSelected: [],
			eventsForQuery: [],

			startDate: null,
			endDate: null,

			getTypeInformation: false,
			getTypeAnomaly: true,
			categorySelected: null,

			isVehicleFilterSelected: true,
			isDriverFilterSelected: false,

			datePickerFooter: "Oggi - #=kendo.toString(data, 'dd MMMM yyyy') #",

			itemVehicleTemplate: "<div style='height: 30px'>#= number_plate # <br /><div style='font-size: 8px'> #= name # </div></div>",
			tagVehicleTemplate: "<div style='height: 30px; text-align: left; padding-top: 3px;'>#= number_plate # <br /><div style='font-size: 8px'> #= name # </div></div>",

			itemDriverTemplate: "<div style='height: 30px'>#= surname # #= name # <br /><div style='font-size: 8px'> #= fiscal_code # </div></div>",
			tagDriverTemplate: "<div style='height: 30px; text-align: left; padding-top: 3px;'>#= surname # #= name #<br /><div style='font-size: 8px'> #= fiscal_code # </div></div>",

			//events
			diagnosticSummaryItems: [],
			diagnosticItems: [],
			configColumns: [],

			//map
			showMap: true,
			config: {
				mapInitialLocation: {
					lat: 43.1107,
					lng: 12.3908
				}
			},
			diagnosticMarker: [],

			//table
			showHorizontalTable: true,
			tableParams: {
				sort: "",
				pageSize: 25
			},
			totalCount: 0,
			canExportGridData: false,
			useReverseGeocoding: false,

			filtersByQuery: false,

			showWarningInformation: false,
			warningInformationProvided: false,
			calendarIndex: 0
		};
	},

	created() {
		window.moment = moment;

		if (this.settings && this.settings.diagnosis.viewType) {
			if (this.settings.diagnosis.viewType == "map, horizontalGrid") {
				this.showMap = true;
				this.showHorizontalTable = true;
			} else if (this.settings.diagnosis.viewType == "horizontalGrid") {
				this.showMap = false;
				this.showHorizontalTable = true;
			} else {
				this.showMap = true;
				this.showHorizontalTable = false;
			}
		}

		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;

		var icon = helpers.getIconForVisualizationType(this.showMap, this.showHorizontalTable, false);
		this.mapTableVisualizationSelected = `../../../${icon}`;

		if (this.settings && this.settings.canExportGridData) {
			this.canExportGridData = true;
		}

		if (this.settings && this.settings.defaultPageSize && this.settings.defaultPageSize > 0) {
			this.tableParams.pageSize = parseInt(this.settings.defaultPageSize);
		}

		if (this.settings && this.settings.diagnosis && this.settings.diagnosis.useReverseGeocoding) this.useReverseGeocoding = this.settings.diagnosis.useReverseGeocoding;

		if (this.$route.query && this.$route.query.vehicleId) {
			this.filtersByQuery = true;
		}

		this.startDate = moment(); //max from api
		this.endDate = moment();
		this.getAllEvents();
		this.getAllVehicles();
		this.getAllDrivers();
		this.getConfig();
		//this.getDiagnosticSummary();
		//this.getDiagnostics();

		bus.$emit("show-spinner-loading");
	},

	mounted() {},

	watch: {
		showTableMapPopover() {
			var self = this;
			self.$root.$emit("bv::hide::tooltip");
			setTimeout(() => {
				self.$root.$emit("bv::hide::tooltip");
			}, 700);
		},
		categorySelected: function(newValue, oldValue) {
			if (newValue) {
				this.events = this.totalEvents.filter(function(item) {
					return item.category_key == newValue;
				});
			} else {
				this.events = this.totalEvents;
			}
			this.eventsSelected = [];

			//bus.$emit("on-category-summary-selected");
		},
		getTypeAnomaly: function(newValue) {
			var self = this;
			if (newValue == false && this.getTypeInformation == false) {
				self.$nextTick(function() {
					self.getTypeAnomaly = true;	
				});
						
			}
		},
		getTypeInformation: function(newValue) {
			if (this.getTypeAnomaly == false && this.getTypeInformation == false) {
				this.getTypeAnomaly = true;			
			}
		}
	},

	methods: {
		//#region filters
		resetFilter() {
			this.vehiclesSelected = [];
			this.driversSelected = [];
			this.eventsSelected = [];
			this.categorySelected = null;
			this.getTypeAnomaly = true;
			this.getTypeInformation = false;

			this.defaultFilterDateRange();
			this.getDiagnosticSummary();
			this.calendarIndex++;
		},
		applyFilter() {
			this.diagnosticItems = [];
			this.getDiagnosticSummary();
			//this.getDiagnostics();
		},
		onFilterTypeChange(type) {
			if (type == "a") {
				this.getTypeAnomaly = !this.getTypeAnomaly;
			}
			if (type == "i") {
				this.getTypeInformation = !this.getTypeInformation;

				if (this.getTypeInformation && !this.warningInformationProvided) {
					this.showWarningInformation = true;
					this.warningInformationProvided = true;

					this.startDate = moment();
					this.endDate = moment();
					this.calendarIndex++;
				} else if (this.getTypeInformation && this.warningInformationProvided) {
					this.startDate = moment();
					this.endDate = moment();

					this.calendarIndex++;
				} else {
					this.calendarIndex++;
				}
			}
			this.setAllTypesIfNoSelected();
			bus.$emit("header-filter-change");
			//this.getDiagnosticSummary();
		},
		setAllTypesIfNoSelected() {
			if (this.getTypeAnomaly == false && this.getTypeInformation == false) {
				this.getTypeAnomaly = this.getTypeInformation = true;
			}
		},
		showMaptable(v) {
			if (v == "ht") {
				this.showHorizontalTable = !this.showHorizontalTable;
			} else if (v == "m") {
				this.showMap = !this.showMap;
			}

			if (!this.showHorizontalTable && !this.showMap) this.showMap = this.showHorizontalTable = true;

			var icon = helpers.getIconForVisualizationType(this.showMap, this.showHorizontalTable, false);
			this.mapTableVisualizationSelected = `../../../${icon}`;

			this.onCloseShowTableMapPopover();
		},
		onCloseShowTableMapPopover() {
			this.showTableMapPopover = false;
		},
		startDateChange(item) {
			var newStartDate = moment(item.sender.value());
			if (newStartDate > moment(this.endDate)) {
				this.endDate = moment(item.sender.value());
			}
			this.startDate = moment(newStartDate).startOf("day");

			bus.$emit("header-filter-change");
			//this.getDiagnosticSummary();
		},

		endDateChange(item) {
			var newEndDate = moment(item.sender.value());
			if (newEndDate < moment(this.startDate)) {
				this.startDate = moment(item.sender.value());
			}
			this.endDate = newEndDate.endOf("day");

			bus.$emit("header-filter-change");
			//this.getDiagnosticSummary();
		},

		filterPlateChange(e) {
			this.vehiclesSelected = e.sender.value();

			bus.$emit("header-filter-change");
			//this.getDiagnosticSummary();
		},
		filterDriverChange(e) {
			this.driversSelected = e.sender.value();

			bus.$emit("header-filter-change");
			//this.getDiagnosticSummary();
		},
		eventSelectedChange(e) {
			this.eventsSelected = e.sender.value();

			//this.getDiagnostics();
		},
		filterCategoryChanged(e) {
			this.categorySelected = e.sender.value();

			//bus.$emit("category-selected-changed", e.sender.value());
		},
		getAllEvents() {
			var self = this;
			ApiService.getVehicleEventsData("diagnosis").then(res => {
				self.eventsForQuery = res
					.filter(function(item) {
						return item.description && item.description.length > 0;
					})
					.map(function(item) {
						return {
							id: item.description.toLowerCase(),
							value: item.description.toLowerCase(),
							queryValue: `${item.box_payload_id}${item.box_type_id ? "_" + item.box_type_id : ""}${item.box_cat_id ? "_" + item.box_cat_id : ""}`,
							category_key: item.category_key
						};
					});

				for (var i = 0; i < self.eventsForQuery.length; i++) {
					var evt = self.eventsForQuery[i];
					var existsEvent = self.events.findIndex(item => {
						return item.id == evt.id;
					});
					if (existsEvent < 0) {
						self.events.push(evt);
					}
				}

				self.events = self._.sortBy(self.events, function(item) {
					return item.id;
				});

				self.totalEvents = self.events;

				//CATEGORY
				self.categories = res
					.filter(function(item) {
						return item.category_key && item.category_key.length > 0;
					})
					.map(function(item) {
						return {
							id: item.category_key.toLowerCase(),
							value: item.category_key.toLowerCase()
						};
					});

				self.categories = self._.uniqBy(self.categories, "id");

				self.categories = self._.sortBy(self.categories, function(item) {
					return item.id;
				});

				self.categories.unshift({
					id: "",
					value: ""
				});
			});
		},
		getAllVehicles: function() {
			var self = this;
			ApiService.getVehiclesLookup({ page: 0, pageSize: 1000000 }, this.vehicleIdFilterField).then(res => {
				self.vehicles = res.items.map(function(vehicle) {
					return {
						id: vehicle.id,
						name: vehicle.name,
						number_plate: vehicle.number_plate,
						name_numberplate: `${vehicle.number_plate} ${vehicle.name}`
					};
				});
			});
		},
		getAllDrivers() {
			var self = this;
			ApiService.getDriversData({ page: 0, pageSize: 100000, onlyActiveWithBox: true }).then(res => {
				self.drivers = res.items.map(function(driver) {
					return {
						id: driver.id,
						name: driver.name ? driver.name.toLowerCase() : "",
						surname: driver.surname ? driver.surname.toLowerCase() : "",
						name_surname_fiscalcode: `${driver.name} ${driver.surname} ${driver.fiscal_code}`,
						fiscal_code: driver.fiscal_code
					};
				});

				self.drivers = self._.sortBy(self.drivers, ["surname", "name"]);

				self.drivers.unshift({
					id: 0,
					name: "NON DISPONIBILE",
					surname: "",
					fiscal_code: ""
				});
			});
		},
		//#endregion

		//#region table
		onFilterDaterangeChange(e) {
			if (e.reset) {
				this.startTime = null;
				this.endTime = null;
				this.defaultFilterDateRange();
			} else if (e.type == "date") {
				this.startDate = e.startDate;
				this.endDate = e.endDate;
			} else if (e.type == "time") {
				this.startTime = e.startTime;
				this.endTime = e.endTime;
			}
		},
		defaultFilterDateRange() {
			var startTime = moment();
			this.startDate = startTime; //max from api
			var endDate = moment();
			this.endDate = endDate;
		},
		downloadHtXlsx(type) {
			var self = this;
			var query = this.getQueryParams();
			if (type == "csv") query["format"] = "csv";
			ApiService.exportXlsx("diagnosis", query).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `Diagnostica.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		},
		downloadVtXlsx(type) {
			var self = this;
			var query = {};

			let filterPlatesSelected = [];
			for (var i = 0; i < this.vehiclesSelected.length; i++) {
				let vehicleId = this.vehiclesSelected[i];
				let vehicle = this.vehicles.find(function(x) {
					return x.id == vehicleId;
				});

				if (vehicle) filterPlatesSelected.push(vehicle.id);
			}

			if (filterPlatesSelected.length > 0) query.vehicles = filterPlatesSelected;

			let driverPlatesSelected = [];
			for (var i = 0; i < this.driversSelected.length; i++) {
				let driverId = this.driversSelected[i];
				let driver = this.drivers.find(function(x) {
					return x.id == driverId;
				});

				if (driver) driverPlatesSelected.push(driver.id);
			}

			if (driverPlatesSelected.length > 0) query.drivers = driverPlatesSelected;

			if (this.startDate) {
				query["dateRange.from"] = moment(this.startDate)
					.startOf("day")
					.utc()
					.format();
			}

			if (this.endDate) {
				query["dateRange.to"] = moment(this.endDate)
					.endOf("day")
					.utc()
					.format();
			}

			if (this.tableParams) {
				if (this.tableParams.sort && this.tableParams.sort.length > 0) {
					var sortParam = "";
					for (var i = 0; i < this.tableParams.sort.length; i++) {
						if (i > 0) sortParam += ",";

						var fieldAndDir = this.tableParams.sort[i];
						sortParam += `${fieldAndDir.field}|${fieldAndDir.dir}`;
					}

					query["sort"] = sortParam;
				}
			}

			var types = [];
			if (this.getTypeAnomaly) types.push("anomaly_event");
			if (this.getTypeInformation) types.push("info_event");

			if (types.length > 0) {
				query.types = types;
			}

			if (type == "csv") query["format"] = "csv";
			ApiService.exportXlsx("diagnosis/summary", query).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `Sommario Diagnostica.${type}"`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		},
		onSortOrPageChangeHandler(query) {
			this.tableParams = query;
			this.getDiagnostics();
		},
		onHtFilterHandler(query) {
			this.tableParams = query;
			//this.getDiagnostics();
			this.getDiagnosticSummary();
		},
		onHtEventFilterHandler(query) {
			this.tableParams = query;
			this.getDiagnostics();
			//this.getDiagnosticSummary();
		},
		onVisibilityItemChange(dataItem) {
			if (dataItem) {
				if (dataItem.visible) {
					var itemToShow = this.diagnosticItems.find(function(item) {
						return item.id === dataItem.id;
					});

					var indexOfMarker = this.diagnosticMarker.findIndex(function(item) {
						return item.id == dataItem.id;
					});

					if (indexOfMarker < 0) {
						this.diagnosticMarker.push(itemToShow);
					}
				} else {
					var markerToRemoveIndex = this.diagnosticMarker.findIndex(function(item) {
						return item.id === dataItem.id;
					});

					if (markerToRemoveIndex >= 0) {
						this.diagnosticMarker.splice(markerToRemoveIndex, 1);
					}
				}
			}
		},
		onSummarySelectedRow(e) {
			if (e) {
				this.categorySelected = e.category;
				this.getDiagnosticSummary();
			}
		},
		onSelectedRow(e) {
			var itemToShow = this.diagnosticItems.find(function(item) {
				return item.id === e.id;
			});

			if (itemToShow && itemToShow.position) {
				itemToShow.visible = true;

				var alreadyExistItem =
					this.diagnosticMarker.findIndex(function(item) {
						return item.id === e.id;
					}) >= 0;

				if (!alreadyExistItem) {
					this.diagnosticMarker.push(itemToShow);
				} else {
					bus.$emit("on-diagnostic-selected-row", e);
				}
			}
		},
		//#endregion

		//#region map
		onMarkerClick(e) {
			bus.$emit("alarm-marker-click", e);
		},
		//#endregion

		//#region Diagnostic Summary
		getConfig: function() {
			var self = this;
			ApiService.getViewConfig("fleerun_diagnosis").then(res => {
				self.configColumns = res;

				// if (res && res.length) {
				// 	var positionDisplayNameField = res.find(function(item) {
				// 		return item.field == valoredelcampodacercare;
				// 	});

				// 	if (positionDisplayNameField && positionDisplayNameField.enabled == false) {
				// 		this.useReverseGeocoding = false;
				// 	}
				// }

				self.getDiagnosticSummary();
			});
		},
		getDiagnosticSummary() {
			var self = this;
			var query = {};
			bus.$emit("show-spinner-loading");

			if (this.getTypeAnomaly == false && this.getTypeInformation) {

			} 
			
			let filterPlatesSelected = [];
			for (var i = 0; i < this.vehiclesSelected.length; i++) {
				let vehicleId = this.vehiclesSelected[i];
				let vehicle = this.vehicles.find(function(x) {
					return x.id == vehicleId;
				});

				if (vehicle) filterPlatesSelected.push(vehicle.id);
			}

			if (self.filtersByQuery && self.$route.query && self.$route.query.vehicleId) {
				var numberPlateFiltered = self.$route.query.vehicleId;
				setTimeout(() => {
					var vehicleSelected = self.vehicles.find(item => {
						return item.number_plate.toLowerCase() == numberPlateFiltered.toLowerCase();
					});
					if (vehicleSelected) self.vehiclesSelected.push(vehicleSelected.id);
				}, 200);
				if (self.vehicleIdFilterField == "code") {
					filterPlatesSelected.push(self.$route.query.code);
				} else {
					filterPlatesSelected.push(numberPlateFiltered);
				}

				if (self.$route.query.startDay) {
					self.startDate = moment(self.$route.query.startDay).startOf("day");
					self.endDate = moment(self.$route.query.startDay).endOf("day");
				}

				if (self.$route.query.anomalyType && self.$route.query.anomalyType.length > 0) {
					let anomalyTypes = self.$route.query.anomalyType;
					if (anomalyTypes.length == 2) {
						this.getTypeAnomaly = true;
						this.getTypeInformation = true;
					} else {
						if (anomalyTypes[0] == "anomaly_event") {
							this.getTypeAnomaly = true;
							this.getTypeInformation = false;
						} else {
							this.getTypeAnomaly = false;
							this.getTypeInformation = true;
						}
					}
				}
			}

			if (filterPlatesSelected.length > 0) query.vehicles = filterPlatesSelected;

			let driverPlatesSelected = [];
			for (var i = 0; i < this.driversSelected.length; i++) {
				let driverId = this.driversSelected[i];
				let driver = this.drivers.find(function(x) {
					return x.id == driverId;
				});

				if (driver) driverPlatesSelected.push(driver.id);
			}

			if (driverPlatesSelected.length > 0) query.drivers = driverPlatesSelected;

			if (this.startDate) {
				query["dateRange.from"] = moment(this.startDate)
					.startOf("day")
					.utc()
					.format();
			}

			if (this.endDate) {
				query["dateRange.to"] = moment(this.endDate)
					.endOf("day")
					.utc()
					.format();
			}

			if (this.tableParams) {
				if (this.tableParams.sort && this.tableParams.sort.length > 0) {
					var sortParam = "";
					for (var i = 0; i < this.tableParams.sort.length; i++) {
						if (i > 0) sortParam += ",";

						var fieldAndDir = this.tableParams.sort[i];
						sortParam += `${fieldAndDir.field}|${fieldAndDir.dir}`;
					}

					query["sort"] = sortParam;
				}
			}

			var types = [];
			if (this.getTypeAnomaly) types.push("anomaly_event");
			if (this.getTypeInformation) types.push("info_event");

			if (types.length > 0) {
				query.types = types;
			}

			ApiService.getDiagnosticSummaryData(query).then(res => {
				if (res) {
					self.diagnosticSummaryItems = [];
					self.diagnosticItems = [];
					self.diagnosticSummaryItems = res.map(a => {
						return {
							category: a.category,
							display_category: a.display_category,
							count: a.count,
							last_event_date: a.last_event_date
						};
					});

					//self.categorySelected = null;
					self.$nextTick(function() {
						if (self.categorySelected) {
							bus.$emit("category-selected-changed", self.categorySelected);
						}
					});
					bus.$emit("on-summary-get-data");
					self.tableParams.page = 0;
					//self.eventsSelected = [];

					if (self.diagnosticSummaryItems && self.diagnosticSummaryItems.length) {
						self.getDiagnostics();
					}
					else {
						bus.$emit("hide-spinner-loading");
					}
				}
			});
		},

		//#endregion
		//#region Diagnostic Detail Data
		getQueryParams() {
			var query = {};

			let filterPlatesSelected = [];

			for (var i = 0; i < this.vehiclesSelected.length; i++) {
				let vehicleId = this.vehiclesSelected[i];
				let vehicle = this.vehicles.find(function(x) {
					return x.id == vehicleId;
				});

				if (vehicle) filterPlatesSelected.push(vehicle.id);
			}

			if (self.filtersByQuery && self.$route.query && self.$route.query.vehicleId) {
				var numberPlateFiltered = self.$route.query.vehicleId;
				setTimeout(() => {
					var vehicleSelected = self.vehicles.find(item => {
						return item.number_plate.toLowerCase() == numberPlateFiltered.toLowerCase();
					});
					if (vehicleSelected) self.vehiclesSelected.push(vehicleSelected.id);
				}, 200);
				if (self.vehicleIdFilterField == "code") {
					filterPlatesSelected.push(self.$route.query.code);
				} else {
					filterPlatesSelected.push(numberPlateFiltered);
				}

				if (self.$route.query.startDay) {
					self.startDate = moment(self.$route.query.startDay).startOf("day");
					self.endDate = moment(self.$route.query.startDay).endOf("day");
				}
			}

			if (filterPlatesSelected.length > 0) query.vehicles = filterPlatesSelected;

			let driverPlatesSelected = [];
			for (var i = 0; i < this.driversSelected.length; i++) {
				let driverId = this.driversSelected[i];
				let driver = this.drivers.find(function(x) {
					return x.id == driverId;
				});

				if (driver) driverPlatesSelected.push(driver.id);
			}

			if (driverPlatesSelected.length > 0) query.drivers = driverPlatesSelected;

			if (this.startDate) {
				query["dateRange.from"] = moment(this.startDate)
					.startOf("day")
					.utc()
					.format();
			}

			if (this.endDate) {
				query["dateRange.to"] = moment(this.endDate)
					.endOf("day")
					.utc()
					.format();
			}

			if (this.tableParams) {
				if (this.tableParams.sort && this.tableParams.sort.length > 0) {
					var sortParam = "";
					for (var i = 0; i < this.tableParams.sort.length; i++) {
						if (i > 0) sortParam += ",";

						var fieldAndDir = this.tableParams.sort[i];
						sortParam += `${fieldAndDir.field}|${fieldAndDir.dir}`;
					}

					query["sort"] = sortParam;
				}

				if (this.tableParams.page || this.tableParams.page == 0) {
					query["page"] = this.tableParams.page;
				}

				if (this.tableParams.pageSize) {
					query["pageSize"] = this.tableParams.pageSize;
				}
			}

			//types selected
			var types = [];
			if (this.categorySelected) query.categoryKey = this.categorySelected;
			if (this.getTypeAnomaly) types.push("anomaly_event");
			if (this.getTypeInformation) types.push("info_event");

			if (types.length > 0) {
				query.types = types;
			}

			var evtForQuery = [];
			for (var i = 0; i < this.eventsSelected.length; i++) {
				var evtSelected = this.eventsSelected[i];
				var evts = this.eventsForQuery.filter(item => {
					return item.id == evtSelected;
				});

				if (evts && evts.length > 0) evtForQuery = evtForQuery.concat(evts);
			}
			if (evtForQuery.length > 0) {
				query.eventKey = evtForQuery.map(item => {
					return item.queryValue;
				});
			}

			return query;
		},
		getDiagnostics() {
			var self = this;
			bus.$emit("show-spinner-loading");

			var query = this.getQueryParams();

			ApiService.getDiagnosticData(query)
				.then(res => {
					if (res && res.items) {
						var oldDiagnostics = self._.clone(self.diagnosticItems);
						self.diagnosticItems = [];
						self.diagnosticItems = res.items.map(a => {
							return {
								id: a.id,
								trip_id: a.trip_id,
								event_date: a.event_date,
								box_serial_number: a.box_serial_number,
								number_plate: a.number_plate,
								vehicle_id: a.vehicle_id,
								vehicle_name: a.vehicle_name,
								vehicle_code: a.vehicle_code,
								driver_id: a.driver_id,
								driver_name: a.driver_name,
								type: a.type,
								subtype: a.subtype,
								icon: a.icon,
								car_gear_position_type: a.car_gear_position_type,
								type_name: a.type_name,
								description: a.description,
								timestamp: a.timestamp,
								mas: a.mas,
								speed: a.speed,
								position: a.position,
								position_name: a.position_display_name,
								drive_direction: a.drive_direction,
								data_category_description: a.data_category_description,
								data: a.data,
								event_date: a.event_date,
								visible: self.getVisibilityOfItems(a, oldDiagnostics),
								diagnostic_description: a.description,
								value: a.data && a.data.value ? a.data.value : "",
								um: a.data && a.data.unit ? a.data.unit : "",
								parameter: a.data && a.data.parameter ? a.data.parameter : ""
							};
						});

						self.totalCount = res.totalCount;

						if (self.diagnosticMarker && self.diagnosticMarker.length > 0 && self.diagnosticItems) {
							//remove markers if needed
							var markerToRemove = [];
							for (var i = 0; i < self.diagnosticMarker.length; i++) {
								var ai = self.diagnosticMarker[i];
								var diagnosis = self.diagnosticItems.find(m => {
									return m.id == ai.id;
								});

								if (!(diagnosis && diagnosis.visible)) {
									markerToRemove.push(ai.id);
								}
							}

							for (var i = 0; i < markerToRemove.length; i++) {
								let id = markerToRemove[i];
								let index = self.diagnosticMarker.findIndex(function(a) {
									return a.id == id;
								});

								if (index >= 0) {
									self.diagnosticMarker.splice(index, 1);
								}
							}
						}

						if (self.filtersByQuery && self.$route.query && self.$route.query.diagnosisId) {
							var diagnosis = self.diagnosticItems.find(item => {
								return item.id == self.$route.query.diagnosisId;
							});

							if (diagnosis) diagnosis.visible = true;

							self.onVisibilityItemChange(diagnosis);

							self.filtersByQuery = false;
						}

						//Discovery the position name by reverse geocoding
						//if (this.useReverseGeocoding) self.setAddress();
					}
				})
				.finally(() => {
					bus.$emit("hide-spinner-loading");
				});
		},
		setAddress() {
			var self = this;
			for (var i = 0; i < self.diagnosticItems.length; i++) {
				var item = self.diagnosticItems[i];

				if (self._.isNull(item.position_name) && item.position) {
					var params = {
						latitude: item.position.lat,
						longitude: item.position.lon
					};

					var getAddress = function(item, params) {
						ApiService.getReverseGeocoding(params).then(res => {
							var itemToUpdate = item;
							if (res && res.length > 0) {
								var newAddress = self._.find(res, function(item) {
									return (
										self._.find(item.types, function(x) {
											return x === "streetAddress";
										}) != null
									);
								});

								if (!newAddress) {
									newAddress = res[0];
								}

								var address = "";
								if (newAddress && newAddress.formattedAddress) {
									address = newAddress.formattedAddress;
								}
								itemToUpdate.position_name = address;
							}
						});
					};

					getAddress(item, params);
				}
			}
		},
		getVisibilityOfItems(newItem, oldDiagnosticItems) {
			if (newItem.position != null) {
				if (oldDiagnosticItems.length > 0) {
					var oldItem = oldDiagnosticItems.find(function(o) {
						return o.id == newItem.id;
					});

					if (oldItem) {
						return oldItem.visible;
					} else {
						return false;
					}
				}

				return false;
			}

			return null;
		},
		disableDates: function(dateformatted) {
			if (this.getTypeInformation && Object.prototype.toString.call(dateformatted) === Object.prototype.toString.call(new Date())) {
				var fromDisabledDay = moment().add(-7, "days");

				try {
					var date = moment(dateformatted);

					if (date._isValid && date < fromDisabledDay) {
						return true;
					} else {
						return false;
					}
				} catch (ex) {
					return false;
				}
			}
		},
		acceptInformationEnabled: function() {
			this.showWarningInformation = false;

			this.startDate = moment();
			this.endDate = moment();

			this.calendarIndex++;
		},
		denyInformationEnabled: function() {
			this.getTypeInformation = false; 
			this.showWarningInformation = false
		}
		//#endregion
	},

	computed: {
		...mapGetters(["settings"]),
		startDateString() {
			return moment(this.startDate).format("DD MMMM YYYY");
		},
		endDateString() {
			return moment(this.endDate).format("DD MMMM YYYY");
		},
		mapClass() {
			if (this.showHorizontalTable) {
				return "mapwithHorizontalTable";
			}

			return "mapNoTables";
		},
		tableClass: function() {
			if (!this.showMap) {
				return " horizontal-table-without-map";
			}

			return "";
		},
		getStateMIcon() {
			return `../../../${helpers.getStateMIcon(this.showMap)}`;
		},
		getStateHTIcon() {
			return `../../../${helpers.getStateHTIcon(this.showHorizontalTable)}`;
		}
		// disableDates(dateformatted) {
		// 	console.log("test");
		// 	if (this.getTypeInformation && Object.prototype.toString.call(dateformatted) === Object.prototype.toString.call(new Date())) {
		// 		var fromDisabledDay = moment().add(-7, "days");

		// 		try {
		// 			var date = moment(dateformatted);

		// 			if (date._isValid && date < fromDisabledDay) {
		// 				return true;
		// 			} else {
		// 				return false;
		// 			}
		// 		}
		// 		catch(ex) {
		// 			return false;
		// 		}
		// 	}
		// },
	}
};
